"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Icon = _interopRequireDefault(require("./renderers/boolean/Icon"));
var _AppdefsEnum = _interopRequireDefault(require("./renderers/html/AppdefsEnum"));
var _ArrayRenderer = _interopRequireDefault(require("./renderers/html/ArrayRenderer"));
var _Audio = _interopRequireDefault(require("./renderers/html/Audio"));
var _AutoRoster = _interopRequireDefault(require("./renderers/html/AutoRoster"));
var _AutoRosterV = _interopRequireDefault(require("./renderers/html/AutoRosterV2"));
var _CreatedDate = _interopRequireDefault(require("./renderers/html/CreatedDate"));
var _Field = _interopRequireDefault(require("./renderers/html/Field"));
var _FieldAverage = _interopRequireDefault(require("./renderers/html/FieldAverage"));
var _FieldCount = _interopRequireDefault(require("./renderers/html/FieldCount"));
var _FieldRound = _interopRequireDefault(require("./renderers/html/FieldRound"));
var _FieldSum = _interopRequireDefault(require("./renderers/html/FieldSum"));
var _FormatDate = _interopRequireDefault(require("./renderers/html/FormatDate"));
var _Icon2 = _interopRequireDefault(require("./renderers/html/Icon"));
var _IconField = _interopRequireDefault(require("./renderers/html/IconField"));
var _IconNumber = _interopRequireDefault(require("./renderers/html/IconNumber"));
var _Image = _interopRequireDefault(require("./renderers/html/Image"));
var _ImpactButtons = _interopRequireDefault(require("./renderers/html/ImpactButtons"));
var _LastLogin = _interopRequireDefault(require("./renderers/html/LastLogin"));
var _License = _interopRequireDefault(require("./renderers/html/License"));
var _ListRender = _interopRequireDefault(require("./renderers/html/ListRender"));
var _LogCounts = _interopRequireDefault(require("./renderers/html/LogCounts"));
var _NameCount = _interopRequireDefault(require("./renderers/html/NameCount"));
var _NameLastInitial = _interopRequireDefault(require("./renderers/html/NameLastInitial"));
var _QueryEnum = _interopRequireDefault(require("./renderers/html/QueryEnum"));
var _RosteringButtons = _interopRequireDefault(require("./renderers/html/RosteringButtons"));
var _SentenceCase = _interopRequireDefault(require("./renderers/html/SentenceCase"));
var _SessionNum = _interopRequireDefault(require("./renderers/html/SessionNum"));
var _SingleButton = _interopRequireDefault(require("./renderers/html/SingleButton"));
var _Shorten = _interopRequireDefault(require("./renderers/html/Shorten"));
var _SumTotalList = _interopRequireDefault(require("./renderers/html/SumTotalList"));
var _UpdatedDate = _interopRequireDefault(require("./renderers/html/UpdatedDate"));
var _XofY = _interopRequireDefault(require("./renderers/html/XofY"));
var _SumofY = _interopRequireDefault(require("./renderers/html/SumofY"));
var _ProgressBar = _interopRequireDefault(require("./renderers/html/ProgressBar"));
var _Permissions = _interopRequireDefault(require("./renderers/html/Permissions"));
var _ProjectPermissions = _interopRequireDefault(require("./renderers/html/ProjectPermissions"));
var _PermittedAdmins = _interopRequireDefault(require("./renderers/html/PermittedAdmins"));
var _LicenseStatus = _interopRequireDefault(require("./renderers/string/LicenseStatus"));
var _Link = _interopRequireDefault(require("./renderers/string/Link"));
var _LinkMany = _interopRequireDefault(require("./renderers/string/LinkMany"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/** A package that exports a collection of generic column renderers for table */
var _default = exports["default"] = {
  "boolean": {
    Icon: _Icon["default"]
  },
  html: {
    AppdefsEnum: _AppdefsEnum["default"],
    ArrayRenderer: _ArrayRenderer["default"],
    Audio: _Audio["default"],
    AutoRoster: _AutoRoster["default"],
    AutoRosterV2: _AutoRosterV["default"],
    CreatedDate: _CreatedDate["default"],
    Field: _Field["default"],
    FieldAverage: _FieldAverage["default"],
    FieldCount: _FieldCount["default"],
    FieldRound: _FieldRound["default"],
    FieldSum: _FieldSum["default"],
    FormatDate: _FormatDate["default"],
    Icon: _Icon2["default"],
    IconField: _IconField["default"],
    IconNumber: _IconNumber["default"],
    Image: _Image["default"],
    ImpactButtons: _ImpactButtons["default"],
    LastLogin: _LastLogin["default"],
    License: _License["default"],
    ListRender: _ListRender["default"],
    LogCounts: _LogCounts["default"],
    NameCount: _NameCount["default"],
    NameLastInitial: _NameLastInitial["default"],
    QueryEnum: _QueryEnum["default"],
    RosteringButtons: _RosteringButtons["default"],
    SentenceCase: _SentenceCase["default"],
    SessionNum: _SessionNum["default"],
    SingleButton: _SingleButton["default"],
    Shorten: _Shorten["default"],
    SumTotalList: _SumTotalList["default"],
    UpdatedDate: _UpdatedDate["default"],
    XofY: _XofY["default"],
    ProgressBar: _ProgressBar["default"],
    SumofY: _SumofY["default"],
    Permissions: _Permissions["default"],
    PermittedAdmins: _PermittedAdmins["default"],
    ProjectPermissions: _ProjectPermissions["default"]
  },
  string: {
    LicenseStatus: _LicenseStatus["default"],
    Link: _Link["default"],
    LinkMany: _LinkMany["default"]
  }
};